import { DecimalPipe } from '@angular/common';
import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[numeric]',
    host: {
        '(input)': '$event'
    },
    standalone: false
})
export class NumericNumbersDirective {

  constructor(
    private el: ElementRef
  ) { }

  @Input('decimals') decimals: any = 0;
  @Input('percentageCheck') percentageCheck: boolean = false;

  private check(value: string, decimals: any)
  {
    if (decimals <= 0) {
      return String(value).match(new RegExp(/^\d*\.?\d*$/));
    } else {
        var regExpString = "^\\s*((\\d+(\\.\\d{0," + decimals + "})?)|((\\d*(\\.\\d{1," + decimals + "}))))\\s*$"
        return String(value).match(new RegExp(regExpString));
    }
  }

  private specialKeys = [ 
    'Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete'
  ];

 

  @HostListener('keydown', [ '$event' ])
  onKeyDown(event) {
      if (this.specialKeys.indexOf(event.key) !== -1) {
          return;
      }
      // Let keyboard shortcuts (copy/paste/select-all) and non-character keys (Shift, arrows…) through.
      if (event.ctrlKey || event.metaKey || event.key.length > 1) {
          return;
      }
      // Do not use event.keycode this is deprecated.
      // See: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
      const input = this.el.nativeElement;
      const rawValue: string = input.value ?? '';
      const start = input.selectionStart ?? rawValue.length;
      const end = input.selectionEnd ?? rawValue.length;

      // Build the value as it would look after inserting the key at the caret/selection, then strip
      // commas. The previous version appended the key to the end, so once a value had 2 decimals any
      // mid-string edit produced 3 decimals and was rejected — forcing the user to clear the field.
      const next: string = (rawValue.slice(0, start) + event.key + rawValue.slice(end)).replace(/\,/g, '');

      if(this.decimals == 2 && Number(next) > 100 && this.percentageCheck){
        event.preventDefault();
        return;
      }
      if ( next && !this.check(next, this.decimals) ) {
         event.preventDefault();
      }

  }

}
